import { FC, useEffect } from 'react';
import { urlParams } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import { loginByLark } from '@/common/api/common';
import { getCookie, setCookie } from '@lhb/cache';
import { Spin } from 'antd';
import { recursiveDecodeURIComponent } from '@/common/utils/ways';
import styles from './entry.module.less';
import V2Message from '@/common/components/Others/V2Hint/V2Message';

const FeishuExemption: FC<{}> = () => {
  // originUrl 出现的场景是访问系统时401，此时记录了要访问的页面，然后重定向到该免登页
  const { appID, originUrl } = urlParams(location.search);
  useEffect(() => {
    if (!appID) return; // 一定要有appID
    if (!window.tt) return; // 判断环境
    const token = getCookie('flow_token');
    const tenantId = getCookie('tenantId');
    const employeeId = getCookie('employeeId');
    if (token && tenantId && employeeId) { // 已经登陆过(此时不考虑token是否失效，在src/common/request/utils.ts中的401逻辑处判断)
      methods.handleJump();
      return;
    }
    const { requestAccess } = window.tt;
    if (requestAccess) { // 支持新版的飞书客户端
      methods.getFeishuCode();
      return;
    }
    methods.callRequestAuthCode(); // 兼容旧版本的飞书
  }, []);

  const methods = useMethods({
    getFeishuCode: () => {
      window.tt.requestAccess({
        appID,
        scopeList: [],
        success: (res) => {
          // 用户授权后返回预授权码
          const { code } = res;
          methods.handleLogin(code);
        },
        fail: (error) => {
          // 需要额外根据errno判断是否为 客户端不支持requestAccess导致的失败
          const { errno, errString } = error;
          // errString
          if (errno === 103) {
            // 客户端版本过低，不支持requestAccess，需要改为调用requestAuthCode
            methods.callRequestAuthCode();
          } else {
            V2Message.error(`${errString}`);

          }
        },
      });
    },
    callRequestAuthCode: () => {
      window.tt.requestAuthCode({
        // 网页应用 App ID
        appId: appID,
        success: (res) => {
          // 用户免登录后返回预授权码
          const { code } = res;
          methods.handleLogin(code);
        },
        fail: (error) => {
          // 免登失败，返回相应的errno和errString
          const { errno, errString } = error;
          V2Message.error(`${errString}`);
          throw new Error(`${errno}:${errString}`);
        },
      });
    },
    handleLogin: (code: string) => { // 通过飞书返回的code、appID，来换取token凭证
      const params = {
        code,
        appID
      };
      loginByLark(params).then((res) => {
        const { token, employeeId, tenantId, errCode, errMsg } = res;
        if (errCode && errMsg) {
          V2Message.error(errMsg);
          return;
        };
        tenantId && setCookie('tenantId', tenantId);
        employeeId && setCookie('employeeId', employeeId);
        token && setCookie('flow_token', token);
        // 刷新页面
        setTimeout(() => {
          methods.handleJump();
        }, 100);
      });
    },
    handleJump: () => {
      if (originUrl) { // 针对如果是因为访问对应页面时还未登录的场景，那就先跳到该授权页面，然后再replace到对应的页面
        const target = recursiveDecodeURIComponent(originUrl);
        window.location.replace(target || '/');
        return;
      }
      window.location.replace('/');
    }
  });
  return (
    <div className={styles.container}>
      <Spin size='large' tip='登录中...'/>
    </div>
  );
};

export default FeishuExemption;
